import React from 'react'
import BaseForm from './base-form.component'
import StyledStepFrom from './styled-step-from.component'
import ComplementaryForm from './complementary-form.component'

export default class StepTwoComplementaryForm extends BaseForm {
	render() {
		return (
			<StyledStepFrom>
				<ComplementaryForm
					initialValues={this.props.initialValues}
					ref={'form'}
					onSubmit={this.handleSubmit}
					onClick={this.handleClick}
				/>
			</StyledStepFrom>
		)
	}
}
